import { queryOptions } from '@tanstack/react-query';
import { ApiError, apiRequest } from '@/lib/http/http-api';
import { queryKeys } from '@/lib/query-keys';

/** Menu visibility only; the server rechecks permissions on every business request. */
export const capabilityQueryOptions = () =>
  queryOptions({
    queryKey: queryKeys.capability,
    queryFn: async ({ signal }): Promise<boolean> => {
      try {
        const capability = await apiRequest<{ canManageUsers: boolean }>(
          '/auth/capabilities',
          { signal },
        );
        return capability.canManageUsers;
      } catch (error) {
        if (error instanceof ApiError && error.accessWasDenied) return false;
        throw error;
      }
    },
    staleTime: 5 * 60_000,
  });
